// PostCardCategory.js
'use strict';
import { connect } from 'react-redux';
import { LRUCache } from 'lru-cache';

import PostCardCategory from '../component/PostCardCategory.jsx';

import fetchFeeds from '../action/fetchFeeds.js';
import getListData from '../selector/getListData.js';
import getNetworkingData from '../selector/getNetworkingData.js';

import { getFeedNameType, sanitizeFeedQuery } from '../resource/feedUtils.js';

const cache = new LRUCache({ max: 128 });
const getSelectPath = ({ category } = {}) => {
  const sanitizedCategory = sanitizeFeedQuery({ feedName: category });

  const key = `${sanitizedCategory}`;
  let result = cache.get(key);

  if (!result) {
    result = ['home', getFeedNameType({ feedName: key }), key];
    cache.set(key, result);
  }
  return result;
};

const mapStateToProps = (state, { category }) => {
  const listSelectPath = getSelectPath({ category });
  const nextPage = getListData(state, listSelectPath, 'nextPage');
  const totalCount = getListData(state, listSelectPath, 'totalCount');
  return {
    nextPage,
    totalCount,
    isNextPageFetching: !!getNetworkingData(
      state,
      [...listSelectPath, nextPage],
      'isFetching'
    ),
    isFirstPageFetched: !!getNetworkingData(
      state,
      [...listSelectPath, 1],
      'isFetched'
    ),
    messageIds: getListData(state, listSelectPath, 'itemIds'),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchFeeds: data => dispatch(fetchFeeds(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PostCardCategory);
